export const consentStatus = {
  APPROVED: 'EINWILLIGUNG_ERTEILT',
  SENT: 'VERSENDET',
  EMPTY: 'NICHT_VORHANDEN',
};
